import React from "react";
//#region types
import { LargeSalaryWarningProps } from "models/propTypes/salaryPropTypes";
import { StyleEnums } from "models/enums";
import { SnackbarKey } from "notistack";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { useFloatingMessages } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const LargeSalaryWarning: React.FC<LargeSalaryWarningProps> = (props) => {
  const { hasLargeSalaries } = props;
  const [largeSalaryMessageKey, setLargeSalaryMessageKey] = React.useState<SnackbarKey>();
  const { enqueueMessage, closeMessage } = useFloatingMessages();

  React.useEffect(() => {
    if (hasLargeSalaries)
      setLargeSalaryMessageKey(
        enqueueMessage(
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.SalaryWarningForLargeSalaries),
          StyleEnums.DisplayType.Warning
        )
      );
    else if (largeSalaryMessageKey) closeMessage(largeSalaryMessageKey);
  }, [hasLargeSalaries]);

  return <></>;
};
export default LargeSalaryWarning;
